"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResize = void 0;
var react_1 = require("react");
var throttle_1 = __importDefault(require("lodash/throttle"));
var useEventListener_1 = require("./useEventListener");
var useResize = function (callback, wait) {
    if (wait === void 0) { wait = 250; }
    var handleResize = (0, react_1.useMemo)(function () {
        return wait !== 0
            ? (0, throttle_1.default)(function (event) { return callback(event); }, wait)
            : function (event) { return callback(event); };
    }, [wait, callback]);
    (0, useEventListener_1.useEventListener)({
        type: 'resize',
        listener: handleResize,
    });
};
exports.useResize = useResize;
